export class C_Features {
  mirrorFeatures: string;
  AddFriends: boolean;
  amountChargeValues: string;
  amountDepositsValues: string;
  APMNetellerChargeEnabled: boolean;
  APMSKrillChargeEnabled: boolean;
  AppVersionPopup: boolean;
  AstropayCreditCardEnabled: boolean;
  AstropayWithdrawalEnabled: boolean;
  ASXDaviPlataChargeEnabled: boolean;
  ASXNequiChargeEnabled: boolean;
  balanceCasinoDetails: boolean;
  bancomerEnabled: boolean;
  BBVAIframeUrl: string;
  BetbuilderEnabled: boolean;
  BetSlipLegMinValue: string;
  BonusSlotsMenuEnabled: boolean;
  CardAssociationAllowed: boolean;
  CardSelectionWithdrawal: boolean;
  CAS_BonusBalanceBDRedirectMOB: any;
  CAS_BonusBalanceBDRedirectPC: any;
  CAS_BonusPlayPlaytechMob: any;
  CAS_BonusPlayPlaytechPc: any;
  CAS_BonusPlayHabMob: any;
  CAS_BonusPlayHabPc: any;
  CAS_BonusNewInterface: boolean;
  CAS_BonusActiveGames: boolean;
  CAS_BonusNumGames: number;
  CAS_NewSummary: boolean;
  CAS_SummaryCanCreateSession: boolean;
  CAS_MobileDontCloseGame: boolean;
  CAS_ShowVisitors: boolean;
  Casino_OmnichannelBackgroundMobile: string;
  Casino_OmnichannelBackgroundPC: string;
  Casino_OmnichannelHeaderMobile: string;
  Casino_OmnichannelHeaderPC: string;
  Casino_URLResponsibleGaming: string;
  CasinoBetslipGames: string;
  CasinoBonusEnabled: boolean;
  Casino_EnabledMultiProviderBonuses: boolean;
  Casino_EnabledMultiCallBonuses: boolean;
  CasinoCalendarEnabled: boolean;
  casinoCalendarName: string;
  CAS_MoreFilters: boolean;
  CAS_GameSessionImprovements: boolean;
  CAS_NewCalendar: boolean;
  CAS_PragmaticGameInfo: string;
  CAS_BonusMsgImg: string;
  CAS_HotjarAllowedRoutes: string;
  CAS_HotjarFormNumber: string;
  CAS_DefaultLobby: string;
  CAS_NewLocationMb: boolean;
  casinoCostLimit: number;
  casinoCostLimitRegulator: number;
  casinoDemoEnabled: boolean;
  casinoEnabled: boolean;
  CasinoLiveGameImageTypeUrl: string;
  casinoLostLimit: number;
  casinoLostLimitRegulator: number;
  CasinoQuickLaunchGames: string;
  casinoTimeLimit: number;
  casinoTimeLimitRegulator: number;
  chatEnabedToFailureDeposit: boolean;
  chatEnabedToFailureRegister: boolean;
  checkTicket: boolean;
  checkTicketFromAzureEnabled: boolean;
  CobHalCashEnabled: boolean;
  CobLocalEnabled: boolean;
  CobPayPalEnabled: boolean;
  CobTransfBancEnabled: boolean;
  CodereMillion: boolean;
  CommunicationsOptions: boolean;
  contactServiceEnabled: boolean;
  CopaAmerica: boolean;
  CopaAmericaAPI: string;
  copaAmericaWidgetEnable: boolean;
  CrowCasinoWDEnabled: boolean;
  csrfControlFront: boolean;
  DaviPlataWithDrawalEnabled: boolean;
  declaracionJuradaPep: string;
  defaultDepositOptionSelected: string;
  DepCredidCardEnabled: boolean;
  DepLocalEnabled: boolean;
  DepOnlineEnabled: boolean;
  depositDayLimit: string;
  depositDayLimitRegulator: string;
  depositLimitRegulatorEndDate: string;
  depositLimitRegulatorStartDate: string;
  depositMonthLimit: string;
  depositMonthLimitRegulator: string;
  depositWeekLimit: string;
  depositWeekLimitRegulator: string;
  DepPaypalEnabled: boolean;
  DepPaysSafeCardEnabled: boolean;
  DocVerification: boolean;
  doLoginwithLoginServices: boolean;
  DynamicYieldClientApiKey: string;
  DynamicYieldClientEngagementUrl: string;
  DynamicYieldRecommendationEnabled: boolean;
  DynamicYieldSportsBetSlipEnabled: boolean;
  EarlyCashoutEnabled: boolean;
  EnabledSelfDiagnosisTest: boolean;
  EnabledSolitics: boolean;
  enableVerificationMessage: boolean;
  EpgCreditCardChargeEnabled: boolean;
  EpgCreditCardEnabled: boolean;
  EPGMuchBetterWithDrawalEnabled: boolean;
  EpgSkrillRapidTransferDepositEnabled: boolean;
  euroCopaWidgetEnable: boolean;
  EventBusApiUrl: string;
  EvoPaymentsEnabled: boolean;
  FiveLoginPopup: boolean;
  ForbiddenSports: any;
  FreeBetAccountVerification: boolean;
  FreeBetEnabled: boolean;
  FreeBetSMSVerification: boolean;
  GeolocationTimespan: number;
  getPendingOnlinePaymentsEnabled: boolean;
  Payments_GracePeriodActive: boolean;
  Payments_GracePeriodDays: number;
  Payments_GracePeriodDepositLimit: number;
  Payments_GracePeriodStart: string;
  HalCashMaxAmount: string;
  HalCashMinAmount: string;
  hideBetFooterBar: boolean;
  IMGOperatorId: string;
  IMGUrlBase: string;
  IosTouchIdEnabled: boolean;
  isOrdenCongelamientoFondos: boolean;
  JackpotCallServiceActive: boolean;
  JackpotLobbyEnabled: boolean;
  JackpotLobbyHeader: string;
  linkNativeDownload: string;
  ListOfGameTypesInCombinedMarket: string;
  ListOfProfesions: string;
  loadTicket: boolean;
  Lobbies: any;
  LobbyAmountStepIncrement: number;
  LobbyMinimumAmount: number;
  loginerrorCode: any;
  loginURLredirect: string;
  LotbaWithdrawalEnabled: boolean;
  MadridMigrationEnabled: boolean;
  maxNumberOfVeridasfail: number;
  MaxTarjetaDepositAmount: number;
  messageServiceEnabled: boolean;
  MexCobLocalEnabled: boolean;
  MexCobTransfBancEnabled: boolean;
  MinBankAccountCharge: number;
  MiniGameGuid: string;
  MiniGameProviderGuid: string;
  MiniGamesEnabled: boolean;
  miniRouletteEnabled: boolean;
  ModalBonusSportCasino: boolean;
  MSO_alertCookiesBtnDecline: boolean;
  MSO_alertCookiesNoBlock: boolean;
  MSO_BannersEndpointURL: string;
  MSO_cardCodereCP: boolean;
  MSO_CheckDNIExpired: boolean;
  MSO_checkElegibleBanners: boolean;
  MSO_CheckProfesion: boolean;
  MSO_EnabledComplianceRegistroCO: boolean;
  MSO_limitsSessionCasino: string;
  MSO_ModalWelcomeBonusContent: string;
  MSO_rsa_publickey: string;
  MSO_UrlNewUserExtractNative: string;
  MSO_UrlNewUserSummaryAuthorize: string;
  MSO_UrlNewUserSummaryNative: string;
  msoNewSelfExclusionAR: boolean;
  msoSelfexclusionURLPBA: string;
  MSO_SelfexclusionURLMZA: string;
  MSO_PersonalInfoPageEnabled: boolean;
  MSO_DocumentationVerificationStatus: boolean;
  MSO_dateRegisterVerificationStatus: string;
  MSO_ShowBankTransferFooterAr: boolean;
  MSO_GraceTimeLogicEnabled: boolean;
  MSO_URLTargetedOptInPopupPage: string;
  MSO_URLPromotionsAPIOptIn: string;
  MSO_URLPromotionsAPIOptOut: string;
  MSO_URLPromotionsAPIWBUser: string;
  MSO_URLPromotionsAPIWBInfo: string;
  MSO_URLPromotionsAPIWBOut: string;
  MSO_URLPromotionsAPIisPromotable: string;
  MSO_URLPromotionsAPIisPromotableVip: string;
  MSO_URLPromotionsAPIisFullPromotable: string;
  MSO_EnableGeolocation: boolean;
  MSO_URLPromotionsAPIList: string;
  MSO_NewCtaPromoPopup: boolean;
  MSO_NewCheckCookieConsent: boolean;
  MSO_newCardCodere_Splash: boolean;
  MSO_TimerGeolocation: boolean;
  MSO_WelcomeBonusCasinoSportsInOne: string;
  MSO_NewAlertsPromotionsPage: boolean;
  MSO_SkipErrorMessagePromotions: string;
  MSO_CommunicationsOptionsLeft: boolean;
  MSO_WelcomeBonusDateLimit: string;
  MSO_WelcomeBonusIDCasino: string;
  MSO_WelcomeBonusIDSports: string;
  MSO_WelcomeBonusImgCasino: string;
  MSO_WelcomeBonusImgSports: string;
  MSO_WelcomeBonusTitleCasino: string;
  MSO_WelcomeBonusTitleSports: string;
  MSO_WelcomeBonusTxtCasino: string;
  MSO_WelcomeBonusTxtSports: string;
  MSO_WelcomeBonusTycCasino: string;
  MSO_WelcomeBonusTycSports: string;
  MSO_WelcomeBonusTycSportsCasino: string;
  MSO_SesionTimer: boolean;
  MSO_LocalDateTimer: boolean;
  MSO_NewReBranding: boolean;
  MSO_SkipAutologin: boolean;
  MSO_NewDecouplingServiceSignup: boolean;
  MSO_DisabledLanguage: boolean;
  MSO_NewLogoutDecoupling: boolean;
  MSO_CookiesRefreshControl: boolean;
  MSO_debounceTimeCookie: string;
  MSO_logoutAfterClosedApp: boolean;
  MSO_DecouplingLimits: boolean;
  MSO_DecouplingInfoPlayer: boolean;
  MSO_DecouplingTrackersCodereId: boolean;
  MSO_NewUrlResponsibleGamblingTest: string;
  MSO_TerminationCodereDecision: boolean;
  MSO_LotbaRevaSystemFailureUrl: string;
  MSO_NewDecouplingSelfExclusion: boolean;
  MSO_NewLogicSelfexclusionCo: boolean;
  MSO_DecouplingTimeOut: boolean;
  MSO_DecouplingQuickExit: boolean;
  MSO_DecouplingLogin: boolean;
  MSO_DecouplingUserData: boolean;
  MSO_NewTimer: boolean;
  MSO_DecouplingBanners: boolean;
  MSO_DecouplingCommunications: boolean;
  MSO_LoginCaptchaDisabled: boolean;
  MSO_SendLinkResetPasswordDecoupling: boolean;
  MSO_ChangePasswordDecoupling: boolean;
  MSO_PromotionsDecoupling: boolean;
  MSO_TermsAndConditions_Decoupling: boolean;
  MSO_TermsAndConditionsSelfie_Decoupling: boolean;
  MSO_PrivacyPolicy_Decoupling: boolean;
  MSO_AuthorizationPersonalData_Decoupling: boolean;
  MSO_RenameKey_Decoupling: boolean;
  MSO_Disable_PromoCode_Check: boolean;
  MSO_Check_PromoCode_Decoupling: boolean;
  MSO_Post_Signup_Decoupling: boolean;
  MVPCodere_IframeURL: string;
  MSO_MaxGraceTimeFD: number;
  MSO_MaxGraceTimeReg: number;
  MSO_OmniChannel_NearestLocalPage: boolean;
  MSO_OmniChannel_NearestLocalPage_Url: string;
  MVPCodere: boolean;
  MVPCodereAPI: string;
  MVPCodereWidgetEnable: boolean;
  myactivity: boolean;
  nationalLimits: boolean;
  nativeAndroidVersion: string;
  NearestLocals: boolean;
  NequiWithDrawalEnabled: boolean;
  NewCarouselActivated: boolean;
  NewCarouselApi: string;
  newChatData: string;
  newChatEnabled: boolean;
  NewLoginServices: boolean;
  NewSports: string;
  notificationEnabled: boolean;
  NotifyBalanceChange: boolean;
  ObjectPromoPreBet: string;
  olympicGamesEnabled: boolean;
  ourLocals: boolean;
  oxxoEnabled: boolean;
  Payments_deposits_URL: string;
  Payments_withdrawals_URL: string;
  //PaymentsV2 Method España
  Payments_Skrill_UsePaymentsv2: boolean;
  Payments_Neteller_UsePaymentsv2: boolean;
  Payments_Cybersource_UsePaymentsv2: boolean;
  Payments_CreditCards_UsePaymentsv2: boolean;
  Payments_Astropay_UsePaymentsv2: boolean;
  Payments_PaySafe_UsePaymentsv2: boolean;
  Payments_Bizum_UsePaymentsv2: boolean;
  Payments_TrueLayer_UsePaymentsv2: boolean;
  Payments_RapidTransfer_UsePaymentsv2: boolean;
  Payments_LocalCodere_UsePaymentsv2: boolean;
  Payments_Paypal_UsePaymentsv2: boolean;
  Payments_BankTransfer_UsePaymentsv2: boolean;
  Payments_HalCash_UsePaymentsv2: boolean;
  //PaymentsV2 Method Argentina
  Payments_Tarjeta_UsePaymentsv2: boolean;
  Payments_Debin_UsePaymentsv2: boolean;
  Payments_MercadoPago_UsePaymentsv2: boolean;
  //PaymentsV2 Method Colombia
  Payments_Pse_UsePaymentsv2: boolean;
  Payments_PayU_UsePaymentsv2: boolean;
  Payments_Daviplata_UsePaymentsv2: boolean;
  Payments_Nequi_UsePaymentsv2: boolean;
  Payments_AlmacenesExito_UsePaymentsv2: boolean;
  Payments_Carulla_UsePaymentsv2: boolean;
  Payments_GanaCerca_UsePaymentsv2: boolean;
  Payments_PagoTodo_UsePaymentsv2: boolean;
  Payments_GanaBank_UsePaymentsv2: boolean;
  Payments_Efecty_UsePaymentsv2: boolean;
  Payments_Dimonex_UsePaymentsv2: boolean;
  Payments_PuntoRed_UsePaymentsv2: boolean;
  Payments_Tpaga_UsePaymentsv2: boolean;
  Payments_VeridasCOActivev3: boolean;
  // Payments retentions withdrawals. Created for later use
  PayRW_UVT: string;
  PayRW_BankTransferWithDrawal: string;
  PayRW_LocalWithDrawal: string;
  PayRW_ItauWithDrawal: string;
  paynetEnabled: boolean;
  PaypalClientEnviorement: string;
  playsstenabled: boolean;
  predictNumberEvents: string;
  Prom10x30Enabled: boolean;
  Promolink: boolean;
  providersGamingBB: string;
  PSEWithDrawalEnabled: boolean;
  pticket: boolean;
  quickExitPageEnabled: boolean;
  RealMadridEnabled: boolean;
  RegistroArRenaper: boolean;
  registroRedirect: string;
  rightMenuSpecialGame: string;
  RiverPlateEnabled: boolean;
  selfExclusionPageEnabled: boolean;
  selfieDocEnabled: boolean;
  SendFrontErrors: boolean;
  SenToPlaytechTriggerBonus: boolean;
  SignalRCasino: string;
  SignalRCasinoJackpots: string;
  SignalRCasinoLiveGames: string;
  SignalRRoyalDegree: boolean;
  cas_uniqueGamesessionEnabled: boolean;
  slotReport: boolean;
  slotsEnabled: boolean;
  SlotsTournament: boolean;
  snapengageChannel: string;
  SPO_BetbuilderEnabled: boolean;
  SPO_betsenseLiveEnabled: boolean;
  SPO_betsenseNonLiveEnabled: boolean;
  SPO_CodereCardPayout_SportsMisc: boolean;
  SPO_CodereFantasyEnabled: boolean;
  SPO_DefaultOverallStake: number;
  SPO_LiveBetbuilderEnabled: boolean;
  SPO_LMTFormula1: boolean;
  SPO_cancelBetFeatureFlagEnabled: boolean;
  SPO_totalOddsFeatureFlagEnabled: boolean;
  targetedOptinPopup: boolean;
  TarjetaCodereEnabled: boolean;
  TemporaryPromoEnabled: boolean;
  timeAlertAr: boolean;
  timeOutPageEnabled: boolean;
  TpagaPaymentEnabled: boolean;
  TrueLayerWithdrawalEnabled: boolean;
  UrlNewUserExtract: string;
  UrlNewUserMyActivity: string;
  UrlNewUserMyActivityExtractable: string;
  UrlNewUserSummary: string;
  urlRegisterLite: string;
  UseBetConfigDataBackEndpoint: boolean;
  userSErviceStandAlone: boolean;
  usertimelogout: any;
  VeridasXpressIdVerificationEnabled: boolean;
  VerticalRouletteGameGuid: string;
  videobingoEnabled: boolean;
  WelcomeMessage: string;
  WitdrawTaxRetentionInformationEnabled: boolean;
  worldCupCalendar: boolean;
  worldCupCenterEnabled: boolean;
  XPInboxEnabled: boolean;
  XPMessagingEnabled: boolean;
  showOriginOfFunds: boolean;
  payValidaPaymentCash: boolean;
  mfaActive: boolean;
  showLocalCodereInfoDelete: boolean;
  depositsJSONApiActive: boolean;
  withdrawalsJSONApiActive: boolean;
  netellerIframeActive: boolean;
  VeridasAutoVerificationEnabledv3: boolean;
  Payments_COLRegCashierTxt_Active: boolean;
  Payments_withdrawalsPaypalWarning_Active: boolean;
  Payments_withdrawalsBankTransferWarning_Active: boolean;
  Payments_withdrawalsOutConditionsURL: string;
  Payments_transferConfig: string;
  Payments_Deposits_IVA_Retention_CO: string;
  Payments_PRAXIS_ES_Redsys_Deposit: boolean;
  Payments_PRAXIS_CABA_MercadoPago_Deposit: boolean;
  appHCPenabled: boolean = true;
  Payments_PRAXIS_ES_Bizum_Deposit: boolean;
  Payments_PRAXIS_ES_Skrill_Deposit: boolean;
  appMaintenanceMode: boolean = false;
  constructor() {
    this.mirrorFeatures = "";
    this.AddFriends = false;
    this.amountChargeValues = "";
    this.amountDepositsValues = "";
    this.amountDepositsValues = "";
    this.APMNetellerChargeEnabled = false;
    this.APMSKrillChargeEnabled = false;
    this.AppVersionPopup = false;
    this.AstropayCreditCardEnabled = false;
    this.AstropayWithdrawalEnabled = false;
    this.ASXDaviPlataChargeEnabled = false;
    this.ASXNequiChargeEnabled = false;
    this.balanceCasinoDetails = false;
    this.bancomerEnabled = false;
    this.BBVAIframeUrl = "";
    this.BetbuilderEnabled = true;
    this.BetSlipLegMinValue = "";
    this.BonusSlotsMenuEnabled = true;
    this.CardAssociationAllowed = false;
    this.CardSelectionWithdrawal = true;
    this.CAS_BonusBalanceBDRedirectMOB = "";
    this.CAS_BonusBalanceBDRedirectPC = "";
    this.CAS_BonusPlayPlaytechMob = "";
    this.CAS_BonusPlayPlaytechPc = "";
    this.CAS_BonusPlayHabMob = "";
    this.CAS_BonusPlayHabPc = "";
    this.CAS_BonusNewInterface = false;
    this.CAS_BonusActiveGames = false;
    this.CAS_BonusNumGames = 20;
    this.CAS_NewSummary = false;
    this.CAS_SummaryCanCreateSession = false;
    this.CAS_MobileDontCloseGame = false;
    this.CAS_ShowVisitors = false;
    this.Casino_OmnichannelBackgroundMobile = "";
    this.Casino_OmnichannelBackgroundPC = "";
    this.Casino_OmnichannelHeaderMobile = "";
    this.Casino_OmnichannelHeaderPC = "";
    this.Casino_URLResponsibleGaming = "";
    this.CasinoBetslipGames = "";
    this.CasinoBonusEnabled = false;
    this.Casino_EnabledMultiProviderBonuses = false;
    this.Casino_EnabledMultiCallBonuses = false;
    this.CasinoCalendarEnabled = false;
    this.casinoCalendarName = "Calendario de Novedades";
    this.CAS_MoreFilters = false;
    this.CAS_GameSessionImprovements = false;
    this.CAS_NewCalendar = false;
    this.CAS_PragmaticGameInfo = "";
    this.CAS_BonusMsgImg = "";
    this.CAS_HotjarAllowedRoutes = "";
    this.CAS_HotjarFormNumber = "";
    this.CAS_DefaultLobby = "";
    this.CAS_NewLocationMb = false;
    this.casinoCostLimit = 0;
    this.casinoCostLimitRegulator = 0;
    this.casinoDemoEnabled = true;
    this.CasinoLiveGameImageTypeUrl = null;
    this.casinoLostLimit = 0;
    this.casinoLostLimitRegulator = 0;
    this.CasinoQuickLaunchGames = "";
    this.casinoTimeLimit = 0;
    this.casinoTimeLimitRegulator = 0;
    this.chatEnabedToFailureDeposit = false;
    this.chatEnabedToFailureRegister = false;
    this.checkTicket = true;
    this.checkTicketFromAzureEnabled = false;
    this.CobHalCashEnabled = true;
    this.CobLocalEnabled = true;
    this.CobPayPalEnabled = true;
    this.CobTransfBancEnabled = true;
    this.CodereMillion = false;
    this.CommunicationsOptions = false;
    this.contactServiceEnabled = false;
    this.CopaAmerica = false;
    this.CopaAmericaAPI = "";
    this.copaAmericaWidgetEnable = false;
    this.CrowCasinoWDEnabled = false;
    this.csrfControlFront = false;
    this.DaviPlataWithDrawalEnabled = false;
    this.declaracionJuradaPep = "";
    this.defaultDepositOptionSelected = "";
    this.DepCredidCardEnabled = true;
    this.DepLocalEnabled = true;
    this.DepOnlineEnabled = true;
    this.depositDayLimit = "0";
    this.depositDayLimitRegulator = "0";
    this.depositLimitRegulatorEndDate = "";
    this.depositLimitRegulatorStartDate = "";
    this.depositMonthLimit = "0";
    this.depositMonthLimitRegulator = "0";
    this.depositWeekLimit = "0";
    this.depositWeekLimitRegulator = "0";
    this.DepPaypalEnabled = true;
    this.DepPaysSafeCardEnabled = true;
    this.DocVerification = true;
    this.doLoginwithLoginServices = false;
    this.DynamicYieldClientApiKey = "";
    this.DynamicYieldClientEngagementUrl = "";
    this.DynamicYieldRecommendationEnabled = false;
    this.DynamicYieldSportsBetSlipEnabled = false;
    this.EarlyCashoutEnabled = true;
    this.EnabledSelfDiagnosisTest = false;
    this.EnabledSolitics = false;
    this.enableVerificationMessage = false;
    this.EpgCreditCardChargeEnabled = false;
    this.EpgCreditCardEnabled = false;
    this.EPGMuchBetterWithDrawalEnabled = false;
    this.EpgSkrillRapidTransferDepositEnabled = false;
    this.euroCopaWidgetEnable = false;
    this.EventBusApiUrl = "";
    this.EvoPaymentsEnabled = false;
    this.FiveLoginPopup = false;
    this.ForbiddenSports = [];
    this.FreeBetAccountVerification = false;
    this.FreeBetEnabled = true;
    this.FreeBetSMSVerification = false;
    this.GeolocationTimespan = 0;
    this.HalCashMaxAmount = "600";
    this.HalCashMinAmount = "20";
    this.hideBetFooterBar = true;
    this.IMGOperatorId = "";
    this.IMGUrlBase = "";
    this.IosTouchIdEnabled = false;
    this.isOrdenCongelamientoFondos = false;
    this.JackpotCallServiceActive = false;
    this.JackpotCallServiceActive = false;
    this.JackpotLobbyHeader = "";
    this.linkNativeDownload = "";
    this.ListOfGameTypesInCombinedMarket =
      "[4,7,39,148,155,175,988,990,991,993,1064,1065,1330,1391,1392,1393,1394,1606,1647,1648,1649,1650,1667,1668,1669,1804,1805,1806,1807,1808,1809]";
    this.ListOfProfesions = "";
    this.loadTicket = true;
    this.Lobbies = [];
    this.LobbyAmountStepIncrement = 1;
    this.LobbyMinimumAmount = 0;
    this.loginerrorCode = [];
    this.loginURLredirect = "";
    this.LotbaWithdrawalEnabled = false;
    this.maxNumberOfVeridasfail = 3;
    this.MaxTarjetaDepositAmount = 10000;
    this.messageServiceEnabled = false;
    this.MexCobLocalEnabled = false;
    this.MexCobTransfBancEnabled = false;
    this.MinBankAccountCharge = 0;
    this.MiniGameGuid = "";
    this.MiniGameProviderGuid = "";
    this.MiniGamesEnabled = false;
    this.miniRouletteEnabled = false;
    this.ModalBonusSportCasino = false;
    this.MSO_alertCookiesBtnDecline = false;
    this.MSO_alertCookiesNoBlock = false;
    this.MSO_alertCookiesNoBlock = false;
    this.MSO_BannersEndpointURL = "";
    this.MSO_BannersEndpointURL = "";
    this.MSO_cardCodereCP = false;
    this.MSO_CheckDNIExpired = false;
    this.MSO_checkElegibleBanners = false;
    this.MSO_CheckProfesion = false;
    this.MSO_EnabledComplianceRegistroCO = false;
    this.MSO_limitsSessionCasino = "";
    this.MSO_ModalWelcomeBonusContent = "ALL";
    this.MSO_PersonalInfoPageEnabled = false;
    this.MSO_SelfexclusionURLMZA = "";
    this.MSO_ShowBankTransferFooterAr = false;
    this.MSO_rsa_publickey = "";
    this.MSO_UrlNewUserExtractNative = "";
    this.MSO_UrlNewUserSummaryAuthorize = "";
    this.MSO_UrlNewUserSummaryNative = "";
    this.MSO_SelfexclusionURLMZA = "";
    this.MSO_PersonalInfoPageEnabled = false;
    this.msoNewSelfExclusionAR = false;
    this.msoSelfexclusionURLPBA = "";
    this.MSO_DocumentationVerificationStatus = false;
    this.MSO_dateRegisterVerificationStatus = "";
    this.MSO_ShowBankTransferFooterAr = false;
    this.MSO_GraceTimeLogicEnabled = false;
    this.MSO_URLTargetedOptInPopupPage = "";
    this.MSO_URLPromotionsAPIOptIn = "";
    this.MSO_URLPromotionsAPIOptOut = "";
    this.MSO_URLPromotionsAPIWBUser = "";
    this.MSO_URLPromotionsAPIWBInfo = "";
    this.MSO_URLPromotionsAPIWBOut = "";
    this.MSO_URLPromotionsAPIisPromotable = "";
    this.MSO_URLPromotionsAPIisPromotableVip = "";
    this.MSO_URLPromotionsAPIisFullPromotable = "";
    this.MSO_EnableGeolocation = false;
    this.MSO_URLPromotionsAPIList = "";
    this.MSO_NewCtaPromoPopup = false;
    this.MSO_newCardCodere_Splash = false;
    this.MSO_TimerGeolocation = false;
    this.MSO_WelcomeBonusCasinoSportsInOne = "";
    this.MSO_NewAlertsPromotionsPage = false;
    this.MSO_SkipErrorMessagePromotions = "";
    this.MSO_CommunicationsOptionsLeft = false;
    this.MSO_WelcomeBonusDateLimit = "";
    this.MSO_WelcomeBonusIDCasino = "";
    this.MSO_WelcomeBonusIDSports = "";
    this.MSO_WelcomeBonusImgCasino = "";
    this.MSO_WelcomeBonusImgSports = "";
    this.MSO_WelcomeBonusTitleCasino = "";
    this.MSO_WelcomeBonusTitleSports = "";
    this.MSO_WelcomeBonusTxtCasino = "";
    this.MSO_WelcomeBonusTxtSports = "";
    this.MSO_WelcomeBonusTycCasino = "";
    this.MSO_WelcomeBonusTycSports = "";
    this.MSO_WelcomeBonusTycSportsCasino = "";
    this.MSO_SesionTimer = false;
    this.MSO_LocalDateTimer = false;
    this.MSO_NewReBranding = false;
    this.MSO_NewDecouplingServiceSignup = false;
    this.MSO_DisabledLanguage = false;
    this.MSO_NewLogoutDecoupling = false;
    this.MSO_CookiesRefreshControl = false;
    this.MSO_debounceTimeCookie = "";
    this.MSO_logoutAfterClosedApp = false;
    this.MSO_DecouplingLimits = false;
    this.MSO_DecouplingInfoPlayer = false;
    this.MSO_NewUrlResponsibleGamblingTest = "";
    this.MSO_TerminationCodereDecision = false;
    this.MSO_LotbaRevaSystemFailureUrl = "";
    this.MSO_NewDecouplingSelfExclusion = false;
    this.MSO_NewLogicSelfexclusionCo = false;
    this.MSO_DecouplingTrackersCodereId = false;
    this.MSO_DecouplingLogin = false;
    this.MSO_NewTimer = false;
    this.MSO_DecouplingTimeOut = false;
    this.MSO_DecouplingQuickExit = false;
    this.MSO_DecouplingUserData = false;
    this.MSO_DecouplingBanners = false;
    this.MSO_MaxGraceTimeFD = 0;
    this.MSO_MaxGraceTimeReg = 0;
    this.MSO_DecouplingCommunications = false;
    this.MSO_LoginCaptchaDisabled = false;
    this.MSO_SendLinkResetPasswordDecoupling = false;
    this.MSO_ChangePasswordDecoupling = false;
    this.MSO_PromotionsDecoupling = false;
    this.MSO_TermsAndConditions_Decoupling = false;
    this.MSO_TermsAndConditionsSelfie_Decoupling = false;
    this.MSO_PrivacyPolicy_Decoupling = false;
    this.MSO_AuthorizationPersonalData_Decoupling = false;
    this.MSO_RenameKey_Decoupling = false;
    this.MSO_Disable_PromoCode_Check = false;
    this.MSO_Check_PromoCode_Decoupling = false;
    this.MSO_OmniChannel_NearestLocalPage = false;
    this.MSO_OmniChannel_NearestLocalPage_Url = "";
    this.MVPCodere = false;
    this.MVPCodere_IframeURL = "";
    this.MVPCodereAPI = "";
    this.MVPCodereWidgetEnable = false;
    this.myactivity = false;
    this.nationalLimits = true;
    this.nativeAndroidVersion = "1.0.4";
    this.NequiWithDrawalEnabled = false;
    this.NewCarouselActivated = false;
    this.NewCarouselApi = "";
    this.newChatData = "";
    this.newChatEnabled = false;
    this.NewLoginServices = false;
    this.NewSports = "";
    this.notificationEnabled = false;
    this.NotifyBalanceChange = true;
    this.ObjectPromoPreBet = "";
    this.olympicGamesEnabled = false;
    this.ourLocals = false;
    this.oxxoEnabled = false;
    this.Payments_Neteller_UsePaymentsv2 = false;
    this.Payments_Neteller_UsePaymentsv2 = false;
    this.Payments_Skrill_UsePaymentsv2 = false;
    this.Payments_Cybersource_UsePaymentsv2 = false;
    this.paynetEnabled = false;
    this.PaypalClientEnviorement = "sandbox";
    this.playsstenabled = false;
    this.predictNumberEvents = "0";
    this.Prom10x30Enabled = false;
    this.Promolink = false;
    this.PSEWithDrawalEnabled = false;
    this.pticket = true;
    this.quickExitPageEnabled = false;
    this.RealMadridEnabled = false;
    this.RegistroArRenaper = true;
    this.registroRedirect = "";
    this.rightMenuSpecialGame = "";
    this.RiverPlateEnabled = false;
    this.selfExclusionPageEnabled = false;
    this.selfieDocEnabled = false;
    this.SendFrontErrors = false;
    this.SenToPlaytechTriggerBonus = false;
    this.SignalRCasino = "";
    this.SignalRCasinoJackpots = "";
    this.SignalRCasinoLiveGames = "";
    this.SignalRRoyalDegree = false;
    this.cas_uniqueGamesessionEnabled = false;
    this.slotReport = true;
    this.SlotsTournament = false;
    this.snapengageChannel = "";
    this.SPO_BetbuilderEnabled = true;
    this.SPO_betsenseLiveEnabled = false;
    this.SPO_betsenseNonLiveEnabled = false;
    this.SPO_CodereCardPayout_SportsMisc = true;
    this.SPO_CodereFantasyEnabled = true;
    this.SPO_DefaultOverallStake = 10;
    this.SPO_LiveBetbuilderEnabled = true;
    this.SPO_LMTFormula1 = true;
    this.SPO_cancelBetFeatureFlagEnabled = false;
    this.SPO_totalOddsFeatureFlagEnabled = false;
    this.JackpotCallServiceActive = false;
    this.MSO_BannersEndpointURL = "";
    this.Payments_deposits_URL = "";
    this.Payments_withdrawals_URL = "";
    this.Payments_Skrill_UsePaymentsv2 = false;
    this.Payments_Neteller_UsePaymentsv2 = false;
    this.Payments_Cybersource_UsePaymentsv2 = false;
    this.Payments_CreditCards_UsePaymentsv2 = false;
    this.Payments_Astropay_UsePaymentsv2 = false;
    this.Payments_PaySafe_UsePaymentsv2 = false;
    this.Payments_Bizum_UsePaymentsv2 = false;
    this.Payments_TrueLayer_UsePaymentsv2 = false;
    this.Payments_RapidTransfer_UsePaymentsv2 = false;
    this.Payments_LocalCodere_UsePaymentsv2 = false;
    this.Payments_Paypal_UsePaymentsv2 = false;
    this.Payments_BankTransfer_UsePaymentsv2 = false;
    this.Payments_HalCash_UsePaymentsv2 = false;
    this.Payments_Tarjeta_UsePaymentsv2 = false;
    this.Payments_Debin_UsePaymentsv2 = false;
    this.Payments_MercadoPago_UsePaymentsv2 = false;
    this.Payments_Pse_UsePaymentsv2 = false;
    this.Payments_PayU_UsePaymentsv2 = false;
    this.Payments_Daviplata_UsePaymentsv2 = false;
    this.Payments_AlmacenesExito_UsePaymentsv2 = false;
    this.Payments_Carulla_UsePaymentsv2 = false;
    this.Payments_GanaCerca_UsePaymentsv2 = false;
    this.Payments_PagoTodo_UsePaymentsv2 = false;
    this.Payments_GanaBank_UsePaymentsv2 = false;
    this.Payments_Nequi_UsePaymentsv2 = false;
    this.Payments_Efecty_UsePaymentsv2 = false;
    this.Payments_Dimonex_UsePaymentsv2 = false;
    this.Payments_Tpaga_UsePaymentsv2 = false;
    this.Payments_VeridasCOActivev3 = false;
    this.Payments_PuntoRed_UsePaymentsv2 = false;
    this.MSO_alertCookiesNoBlock = false;
    this.MSO_ModalWelcomeBonusContent = "ALL";
    this.MSO_NewCheckCookieConsent = false;
    this.Casino_OmnichannelHeaderPC = "";
    this.Casino_OmnichannelHeaderMobile = "";
    this.Casino_OmnichannelBackgroundPC = "";
    this.Casino_OmnichannelBackgroundMobile = "";
    this.MSO_rsa_publickey = "";
    this.targetedOptinPopup = false;
    this.TarjetaCodereEnabled = true;
    this.TemporaryPromoEnabled = false;
    this.timeAlertAr = false;
    this.timeOutPageEnabled = false;
    this.TrueLayerWithdrawalEnabled = false;
    this.UrlNewUserExtract = "";
    this.UrlNewUserMyActivity = "";
    this.UrlNewUserMyActivityExtractable = "";
    this.UrlNewUserSummary = "";
    this.urlRegisterLite = "";
    this.UseBetConfigDataBackEndpoint = true;
    this.userSErviceStandAlone = false;
    this.usertimelogout = 0;
    this.VeridasXpressIdVerificationEnabled = false;
    this.VerticalRouletteGameGuid = "";
    this.WelcomeMessage = "";
    this.WitdrawTaxRetentionInformationEnabled = false;
    this.worldCupCalendar = false;
    this.worldCupCenterEnabled = false;
    this.XPInboxEnabled = false;
    this.XPMessagingEnabled = false;
    this.showOriginOfFunds = false;
    this.payValidaPaymentCash = false;
    this.mfaActive = false;
    this.showLocalCodereInfoDelete = false;
    this.depositsJSONApiActive = false;
    this.withdrawalsJSONApiActive = false;
    this.netellerIframeActive = false;
    this.MSO_SkipAutologin = false;
    this.Payments_COLRegCashierTxt_Active = false;
    this.Payments_withdrawalsPaypalWarning_Active = false;
    this.Payments_withdrawalsBankTransferWarning_Active = false;
    this.Payments_withdrawalsOutConditionsURL = "";
    this.Payments_transferConfig = "";
    this.Payments_Deposits_IVA_Retention_CO = "";
    this.Payments_PRAXIS_ES_Redsys_Deposit = false;
    this.Payments_PRAXIS_CABA_MercadoPago_Deposit = false;
    this.Payments_PRAXIS_ES_Bizum_Deposit = false;
    this.Payments_PRAXIS_ES_Skrill_Deposit = false;
    this.appMaintenanceMode = false;
  }
}
